export default __webpack_public_path__ + "static/media/products.10e534c2.svg";